/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 18:05:31 GMT
 */

module.exports = {
  theme: {
    screens: { xs: "24.375rem", sm: "50rem", md: "80rem", lg: "90rem" },
    borderRadius: {
      sm: "0.25rem",
      lg: "0.5rem",
      DEFAULT: "0.25rem",
      none: "0px",
      full: "9999px",
    },
    boxShadow: {
      xs: "0px 3px 1px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.2)",
      DEFAULT:
        "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.2)",
      sm: "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.2)",
      md: "0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.2)",
      lg: "0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 7px 8px -4px rgba(0, 0, 0, 0.2)",
      xl: "0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.2)",
    },
    colors: {
      neutral: {
        100: "#e6eaef",
        110: "#eceff3",
        120: "#f3f5f7",
        130: "#f9fafb",
        140: "#ffffff",
        "090": "#b4c1cf",
        "080": "#8398af",
        "070": "#637e9c",
        "050": "#405164",
        "040": "#303d4b",
        "030": "#28323e",
        "020": "#202832",
        "010": "#181e25",
        "000": "#101419",
        "060": "#50657c",
      },
      blue: {
        100: "#d8e9fd",
        110: "#e2effe",
        120: "#ecf4fe",
        130: "#f5faff",
        140: "#ffffff",
        "090": "#89befa",
        "080": "#3b93f7",
        "070": "#0a78f5",
        "060": "#0860c4",
        "050": "#074d9d",
        "040": "#053976",
        "030": "#043062",
        "020": "#03264e",
        "010": "#021d3c",
        "000": "#021327",
      },
      green: {
        100: "#dcefdd",
        110: "#e3f2e4",
        120: "#eaf5eb",
        130: "#f1f8f1",
        140: "#ffffff",
        "090": "#8dc98f",
        "080": "#52ad55",
        "070": "#418b44",
        "060": "#316833",
        "050": "#29572a",
        "040": "#244c25",
        "030": "#1d3e1e",
        "020": "#173118",
        "010": "#102311",
        "000": "#0a150a",
      },
      orange: {
        100: "#fbe4da",
        110: "#fceae3",
        120: "#fdf1ed",
        130: "#fef8f6",
        140: "#ffffff",
        "090": "#f2a98c",
        "080": "#ea6f3e",
        "070": "#dc5018",
        "060": "#ae3f13",
        "050": "#8a320f",
        "040": "#6e280c",
        "030": "#5c210a",
        "020": "#491b08",
        "010": "#371406",
        "000": "#250d04",
      },
      red: {
        100: "#fbe0e3",
        110: "#fbe4e7",
        120: "#fcedef",
        130: "#fef6f7",
        140: "#ffffff",
        "090": "#f2a6af",
        "080": "#e96776",
        "070": "#e33b4e",
        "060": "#cd1d32",
        "050": "#981625",
        "040": "#74111c",
        "030": "#620e18",
        "020": "#500b14",
        "010": "#3e090f",
        "000": "#2d060b",
      },
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.25rem",
      xl: "1.5rem",
      "2xl": "1.75rem",
      "3xl": "2rem",
      "4xl": "2.25rem",
      "5xl": "2.5rem",
      "6xl": "2.75rem",
      "9xl": "3.5rem",
      "11xl": "4rem",
    },
    fontWeight: { normal: "400", medium: "500", bold: "700" },
    lineHeight: {
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      13: "3.25rem",
      14: "3.5rem",
      18: "4.5rem",
      20: "5rem",
    },
    fontFamily: {
      sans: ["'AmericanSans Var'", "Helvetica", "Arial", "sans-serif"],
    },
  },
  darkMode: ["class", ":host([aileron-color-scheme=dark])"],
  plugins: [
    {
      handler: function ({ matchUtilities, theme }) {
        matchUtilities(
          {
            icon: (value) => ({
              color: value,
            }),
          },
          {
            values: Object.keys(theme("colors")).reduce((acc, key) => {
              if (typeof theme(`colors.${key}`) === "string") {
                return {
                  ...acc,
                  [key]: theme("colors")[key],
                };
              }

              const colorShades = Object.keys(theme(`colors.${key}`));

              return {
                ...acc,
                ...colorShades.reduce(
                  (a, shade) => ({
                    ...a,
                    [`${key}-${shade}`]: theme(`colors.${key}.${shade}`),
                  }),
                  {}
                ),
              };
            }, {}),
          }
        );
      },
    },
    {
      handler: function ({ matchUtilities, theme }) {
        matchUtilities(
          {
            font: (value) => ({
              fontWeight: value,
              fontVariationSettings: `"wght" ${value}`,
            }),
          },
          {
            values: Object.keys(theme("fontWeight")).reduce((acc, key) => {
              if (typeof theme(`fontWeight.${key}`) === "string") {
                return {
                  ...acc,
                  [key]: theme("fontWeight")[key],
                };
              }

              const fontWeights = Object.keys(theme(`fontWeight.${key}`));

              return {
                ...acc,
                ...fontWeights.reduce(
                  (a, shade) => ({
                    ...a,
                    [`${key}-${shade}`]: theme(`fontWeight.${key}.${shade}`),
                  }),
                  {}
                ),
              };
            }, {}),
          }
        );
      },
    },
    {
      handler: function ({ addBase, theme }) {
        addBase({
          strong: {
            fontWeight: theme("fontWeight.bold"),
            fontVariationSettings: `"wght" 700`,
          },
        });
      },
    },
  ],
  corePlugins: {
    fontWeight: false,
    backgroundOpacity: false,
    borderOpacity: false,
    textOpacity: false,
  },
};
